module.exports = __webpack_public_path__ + "img/v3.3.1dc304ab.png";